module.exports = __webpack_public_path__ + "static/media/18_insideyourblood.1ad1681f.jpg";